import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromAnalytics from '../reducers';
import { Funnel } from '../models/funnel';
import { Referrals } from '../models/referrals';
import { Observable } from 'rxjs/internal/Observable';

@Component({
  selector: 'mj-selected-analytics',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <mj-analytics-details
      fxFlex
      [funnelErrors]="funnelErrors$ | async"
      [referralsErrors]="referralsErrors$ | async"
      [funnel]="funnel$ | async"
      [referrals]="referrals$ | async"
    >
    </mj-analytics-details>
  `,
  styles: [``],
})
export class SelectedAnalyticsComponent implements OnInit {
  id: any;

  funnel$: Observable<Funnel>;
  referrals$: Observable<Referrals>;
  funnelErrors$: Observable<any[]>;
  referralsErrors$: Observable<any[]>;

  constructor(private store: Store<fromAnalytics.State>) {}

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.funnel$ = this.store.select(fromAnalytics.selectFunnel);
    this.funnelErrors$ = this.store.select(
      state => state.analytics.funnel.errors
    );
    this.referrals$ = this.store.select(fromAnalytics.selectReferrals);
    this.referralsErrors$ = this.store.select(
      state => state.analytics.referrals.errors
    );
  }
}
